module.exports = __webpack_public_path__ + "static/img/cont37_01.9e8f032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_01.jpg
// module id = vEp7
// module chunks = 0